import { fetchLaneDetailsYear } from './laneDetailsYearActions';
import { fetchLaneDetails } from './laneDetailsActions';
import { fetchSeasonality } from './seasonalityActions';
import { AppRoles } from '../../../interfaces/authorizationInterfaces';

export const SET_ORIGIN = 'SET_ORIGIN';
export const SET_DESTINATION = 'SET_DESTINATION';
export const SET_EQUIPMENT_TYPE = 'SET_EQUIPMENT_TYPE';

export const setOrigin = (origin: any): object => {
    return {
        type: SET_ORIGIN,
        payload: origin
    };
};

export const setDestination = (destination: any): object => {
    return {
        type: SET_DESTINATION,
        payload: destination
    };
};

export const setEquipmentType = (equipmentType: any): object => {
    return {
        type: SET_EQUIPMENT_TYPE,
        payload: equipmentType
    };
};

export const handleLaneSearch = (searchQuery: any, roles: AppRoles, isTruckLoadRate: boolean = false): Function => {
    return async (dispatch: any): Promise<void> => {
        dispatch(fetchLaneDetails(searchQuery, roles));
        dispatch(fetchLaneDetailsYear(searchQuery));
        if (isTruckLoadRate !== true) {
            dispatch(fetchSeasonality(searchQuery));
        }
    };
};
